/* NEW STATEMENT - cart drawer extras for the AMP Slide Cart:
   1) light grey banner on top with a red 'add 2 items' message
   2) Shipping Protection toggle above the subtotal
   The AMP BUY 1 GET FREE progress bar stays untouched. */
(function () {
  'use strict';
  if (window.__npSP) { return; }
  window.__npSP = true;

  var VARIANT_ID = 59116415877384;
  var DEFAULT_ON = false;
  var ENABLE_PROTECTION = false;            // false = no toggle, banner only
  var TITLE = 'Shipping Protection';
  var DESC = 'Protect your order from loss, damage or theft during shipping.';
  var BANNER_TEXT = 'BUY 1 GET 1 FREE';
  var MSG_TEXT = 'Add 2 pairs to your cart to unlock your free pair';
  var busy = false;
  var priceText = null;
  var hasItemsNow = true;

  var style = document.createElement('style');
  style.textContent =
    (ENABLE_PROTECTION ? '.amp-sc .item[data-variant-id="' + VARIANT_ID + '"]{display:none!important}' : '') +
    '#np-banner{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;background:#f4f4f4;color:#111;text-align:center;padding:10px 12px;line-height:1.25;border-bottom:1px solid #e5e5e5}' +
    '#np-banner .np-bn-title{font-size:16px!important;font-weight:800!important;letter-spacing:.05em;text-transform:uppercase;line-height:1.25!important}' +
    '#np-banner .np-bn-msg{font-size:11px!important;font-weight:600!important;color:#c62828!important;line-height:1.25!important;letter-spacing:0!important;text-transform:none!important}' +
    '#np-sp{display:flex;align-items:center;gap:12px;padding:12px 16px;border-top:1px solid #e5e5e5;background:#f4f4f4;font-family:inherit}' +
    '#np-sp svg{flex:0 0 auto;width:40px;height:40px}' +
    '#np-sp .np-sp-txt{flex:1 1 auto;min-width:0}' +
    '#np-sp .np-sp-top{display:flex;justify-content:space-between;gap:8px;font-weight:700;font-size:13px;letter-spacing:.04em;text-transform:uppercase}' +
    '#np-sp .np-sp-desc{margin-top:2px;font-size:12px;line-height:1.35;color:#777}' +
    '#np-sp label{position:relative;flex:0 0 auto;width:52px;height:30px;cursor:pointer}' +
    '#np-sp input{position:absolute;opacity:0;width:100%;height:100%;margin:0;cursor:pointer}' +
    '#np-sp .np-sp-track{position:absolute;inset:0;border-radius:15px;background:#cfcfcf;transition:background .2s}' +
    '#np-sp .np-sp-track:after{content:"";position:absolute;top:3px;left:3px;width:24px;height:24px;border-radius:50%;background:#fff;transition:transform .2s}' +
    '#np-sp input:checked+.np-sp-track{background:#4cc38a}' +
    '#np-sp input:checked+.np-sp-track:after{transform:translateX(22px)}' +
    '#np-sp[data-busy="1"]{opacity:.6;pointer-events:none}';
  document.head.appendChild(style);

  /* ---------- banner ---------- */
  function paidItems(cart) {
    var n = 0;
    cart.items.forEach(function (i) { if (i.variant_id !== VARIANT_ID) { n += i.quantity; } });
    return n;
  }
  function updateBanner(cart) {
    var b = document.getElementById('np-banner');
    if (cart.items.length === 0) {
      if (b) { b.remove(); }
      return;
    }
    var anchor = document.querySelector('.amp-sc .rewards');
    if (!anchor || !anchor.parentNode) { return; }
    if (!b) {
      b = document.createElement('div');
      b.id = 'np-banner';
      b.innerHTML = '<div class="np-bn-title"></div><div class="np-bn-msg"></div>';
      b.querySelector('.np-bn-title').textContent = BANNER_TEXT;
      b.querySelector('.np-bn-msg').textContent = MSG_TEXT;
      anchor.parentNode.insertBefore(b, anchor);
    }
    // only show the red message while the deal is not unlocked yet (fewer than 2 items)
    b.querySelector('.np-bn-msg').style.display = paidItems(cart) < 2 ? '' : 'none';
  }

  /* ---------- shipping protection toggle ---------- */
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function formatPrice() {
    if (priceText) { return Promise.resolve(priceText); }
    return fetch('/products/shipping-protection-cart.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var cents = p.variants[0].price;
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        try {
          priceText = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100);
        } catch (e) { priceText = (cents / 100).toFixed(2) + ' ' + cur; }
        return priceText;
      })
      .catch(function () { return ''; });
  }

  function hasProtection(cart) {
    return cart.items.some(function (i) { return i.variant_id === VARIANT_ID; });
  }
  function otherItems(cart) {
    return cart.items.filter(function (i) { return i.variant_id !== VARIANT_ID; }).length;
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    window.dispatchEvent(new Event('focus'));
  }

  function setProtection(on) {
    if (busy) { return Promise.resolve(); }
    busy = true;
    var box = document.getElementById('np-sp');
    if (box) { box.setAttribute('data-busy', '1'); }
    var req = on
      ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] }) })
      : fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(VARIANT_ID), quantity: 0 }) });
    return req.then(function () {
      refreshDrawer();
    }).catch(function () {}).then(function () {
      busy = false;
      if (box) { box.removeAttribute('data-busy'); }
      sync();
    });
  }

  function build(price) {
    var d = document.createElement('div');
    d.id = 'np-sp';
    d.innerHTML =
      '<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M32 4 8 13v17c0 15 10 25 24 30 14-5 24-15 24-30V13L32 4z" fill="#4cc38a"/><path d="M22 31l7 7 14-15" fill="none" stroke="#fff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<div class="np-sp-txt"><div class="np-sp-top"><span>' + TITLE + '</span><span>' + price + '</span></div>' +
      '<div class="np-sp-desc">' + DESC + '</div></div>' +
      '<label><input type="checkbox" aria-label="' + TITLE + '"><span class="np-sp-track"></span></label>';
    d.querySelector('input').addEventListener('change', function (e) {
      setProtection(e.target.checked);
    });
    return d;
  }

  function hideAmpLine() {
    if (!ENABLE_PROTECTION) { return; }
    var items = document.querySelectorAll('.amp-sc .items .item');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.closest('#np-sp')) { continue; }
      var txt = (el.textContent || '').toLowerCase();
      if (String(el.getAttribute('data-variant-id')) === String(VARIANT_ID) ||
          el.querySelector('a[href*="shipping-protection"]') ||
          txt.indexOf('shipping protection') > -1) {
        el.style.display = 'none';
      }
    }
  }

  var syncing = false;
  function sync() {
    if (!document.querySelector('.amp-sc')) { return; }
    hideAmpLine();
    if (syncing) { return; }
    syncing = true;
    getCart().then(function (cart) {
      hasItemsNow = cart.items.length > 0;
      updateBanner(cart);
      if (!ENABLE_PROTECTION) {
        var oldBox = document.getElementById('np-sp');
        if (oldBox) { oldBox.remove(); }
        if (hasProtection(cart)) {
          fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(VARIANT_ID), quantity: 0 }) }).then(refreshDrawer);
        }
        return;
      }
      var footer = document.querySelector('.amp-sc footer.footer');
      if (!footer) { return; }
      var existing = document.getElementById('np-sp');
      if (otherItems(cart) === 0) {
        if (hasProtection(cart)) { fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(VARIANT_ID), quantity: 0 }) }).then(refreshDrawer); }
        if (existing) { existing.remove(); }
        return;
      }
      return formatPrice().then(function (price) {
        var f = document.querySelector('.amp-sc footer.footer');
        if (!f) { return; }
        var all = document.querySelectorAll('#np-sp');
        for (var k = 1; k < all.length; k++) { all[k].remove(); }
        var box = document.getElementById('np-sp');
        if (!box) { box = build(price); f.insertBefore(box, f.firstChild); }
        var on = hasProtection(cart);
        var input = box.querySelector('input');
        if (input.checked !== on) { input.checked = on; }
        hideAmpLine();
      });
    }).catch(function () {}).then(function () { syncing = false; });
  }

  var defaultApplied = false;
  function maybeDefaultOn(cart) {
    if (!DEFAULT_ON || defaultApplied || hasProtection(cart) || otherItems(cart) === 0) { return; }
    defaultApplied = true;
    setProtection(true);
  }

  var timer = null;
  new MutationObserver(function () {
    if (timer) { return; }
    timer = setTimeout(function () {
      timer = null;
      hideAmpLine();
      if (hasItemsNow && document.querySelector('.amp-sc') &&
          ((document.querySelector('.amp-sc footer.footer') && !document.getElementById('np-sp')) ||
           (document.querySelector('.amp-sc .rewards') && !document.getElementById('np-banner')))) { sync(); }
    }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });

  var origFetch = window.fetch;
  window.fetch = function () {
    var p = origFetch.apply(this, arguments);
    try {
      var u = String(arguments[0] && arguments[0].url || arguments[0]);
      if (/\/cart\/(add|change|update|clear)/.test(u) && !busy) {
        p.then(function () { setTimeout(function () { getCart().then(maybeDefaultOn); sync(); }, 250); });
      }
    } catch (e) {}
    return p;
  };

  sync();
})();
